import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "options",
        object: "option",
        header: [
            { text: "Opción", value: "option" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        types: ['GENERAL','DRIVER','OWNER']
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
